<div class="goreact-modal account-lockout-modal">
	<div class="goreact-modal-header">
	<h4 class="modal-title" translate="modal-account-locked"></h4>
		<button
			class="close-btn"
			type="button"
			[attr.aria-label]="'common_close' | translate"
			(click)="close()">
			<i class="ficon-app-x"></i>
	</button>
</div>
<div class="goreact-modal-body">
	<div translate="{{data.message}}"></div>
</div>
<div class="goreact-modal-footer">
	<a
		target="_blank"
		href="{{ data.forgotPasswordUrl }}"
		class="pull-left goreact-btn tertiary-btn"
		translate="reset-password_title">
	</a>
	<button
		type="button"
		class="primary-btn"
		(click)="close()"
		translate="common_close">
		</button>
	</div>
</div>
